module.exports = __webpack_public_path__ + "img/detalle-movil2.ec1dda47.png";